import "bootstrap"
import $ from "jquery"

function refreshToasts() {
  $('.toast').toast({
    delay: 5000
  }).toast('show')
}

function refreshTooltips() {
  $("*[data-toggle=tooltip]").tooltip()
}

$(document).on("turbo:load", function () {
  refreshTooltips()
  refreshToasts()
})
